export default "__VITE_ASSET__C7hWuPz3__"